import Swal from "sweetalert2";

const customSwal = Swal.mixin({
    customClass:{
        title:'fs-5',
        htmlContainer:'p-0 my-2 mx-1',
        confirmButton: 'py-1 px-4 btn btn-primary focus-no',
        cancelButton: 'py-1 px-4 btn btn-cancel focus-no',
        actions:'mt-0'
    },
    width : '95%',
    confirmButtonText: '확인',
    cancelButtonText: '취소'
})

export { customSwal }
